import { baseUrl } from '@/api/types';

export function notificationIndexUrl() {
  return `${baseUrl}/notifications`;
}

export function notificationUpdateUrl() {
  return `${baseUrl}/notifications`;
}

export function notificationDeleteUrl(notificationId) {
  return `${notificationIndexUrl()}/${notificationId}`;
}

export function hideSipNotificationUrl($id) {
  return `${baseUrl}/sip/hide-notification/${$id}`;
}

export function hideSipExpiredNotificationUrl() {
  return `${baseUrl}/sip/hide-expired-contracts-notification`;
}
